import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CalendarIcon, ClockIcon, ArrowRightIcon } from 'lucide-react';
import { blogPosts } from '../data/blog';
import { Button } from '../components/ui/Button';
export function BlogPage() {
  return <main className="min-h-screen bg-slate-50" data-id="element-417">
      {/* Breadcrumbs */}
      <div className="bg-white border-b border-slate-100" data-id="element-418">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-419">
          <nav className="flex items-center gap-2 text-sm" data-id="element-420">
            <Link to="/" className="text-slate-500 hover:text-slate-700" data-id="element-421">
              Головна
            </Link>
            <span className="text-slate-300" data-id="element-422">/</span>
            <span className="text-slate-900 font-medium" data-id="element-423">Блог</span>
          </nav>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-424">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-425">
          <h1 className="text-4xl font-bold text-slate-900 mb-4" data-id="element-426">
            Блог та корисні поради
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-427">
            Ділимося досвідом догляду за басейном, вибору обладнання та
            створення ідеальної зони відпочинку
          </p>
        </div>

        {/* Featured Post */}
        <div className="mb-12" data-id="element-428">
          <Link to={`/blog/${blogPosts[0].id}`} className="group relative block rounded-3xl overflow-hidden shadow-lg aspect-[21/9] md:aspect-[21/8]" data-id="element-429">
            <img src={blogPosts[0].image} alt={blogPosts[0].title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-430" />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/40 to-transparent" data-id="element-431" />
            <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10" data-id="element-432">
              <div className="max-w-3xl" data-id="element-433">
                <span className="inline-block px-3 py-1 bg-sky-500 text-white text-sm font-semibold rounded-lg mb-4" data-id="element-434">
                  {blogPosts[0].category}
                </span>
                <h2 className="text-2xl md:text-4xl font-bold text-white mb-4 group-hover:text-sky-200 transition-colors" data-id="element-435">
                  {blogPosts[0].title}
                </h2>
                <p className="text-slate-200 text-lg mb-6 line-clamp-2 md:line-clamp-none" data-id="element-436">
                  {blogPosts[0].excerpt}
                </p>
                <div className="flex items-center gap-6 text-slate-300 text-sm" data-id="element-437">
                  <div className="flex items-center gap-2" data-id="element-438">
                    <CalendarIcon className="w-4 h-4" data-id="element-439" />
                    {blogPosts[0].date}
                  </div>
                  <div className="flex items-center gap-2" data-id="element-440">
                    <ClockIcon className="w-4 h-4" data-id="element-441" />
                    {blogPosts[0].readTime}
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>

        {/* Posts Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-442">
          {blogPosts.slice(1).map((post, index) => <motion.article key={post.id} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 flex flex-col h-full" data-id="element-443">
              <Link to={`/blog/${post.id}`} className="block aspect-[16/10] overflow-hidden" data-id="element-444">
                <img src={post.image} alt={post.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" data-id="element-445" />
              </Link>
              <div className="p-6 flex-1 flex flex-col" data-id="element-446">
                <div className="flex items-center gap-3 text-xs font-medium mb-3" data-id="element-447">
                  <span className="text-sky-600 bg-sky-50 px-2 py-1 rounded-md" data-id="element-448">
                    {post.category}
                  </span>
                  <span className="text-slate-400" data-id="element-449">•</span>
                  <span className="text-slate-500" data-id="element-450">{post.readTime}</span>
                </div>
                <Link to={`/blog/${post.id}`} data-id="element-451">
                  <h3 className="text-xl font-bold text-slate-900 mb-3 hover:text-sky-600 transition-colors line-clamp-2" data-id="element-452">
                    {post.title}
                  </h3>
                </Link>
                <p className="text-slate-600 text-sm mb-4 line-clamp-3 flex-1" data-id="element-453">
                  {post.excerpt}
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-slate-100 mt-auto" data-id="element-454">
                  <span className="text-xs text-slate-400" data-id="element-455">{post.date}</span>
                  <Link to={`/blog/${post.id}`} className="text-sm font-medium text-sky-600 hover:text-sky-700 flex items-center gap-1" data-id="element-456">
                    Читати далі
                    <ArrowRightIcon className="w-4 h-4" data-id="element-457" />
                  </Link>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </main>;
}